<template>
  <div class="p-10 md:p-15 bg-gray-100 border border-gray-300 mb-30">
    <div>
      <SpriteSymbol
        name="pharmasuisse"
        class="w-40 h-40 float-right text-green-alt"
      />

      <h3 class="text-md md:text-lg !leading-none font-semibold">
        {{ $texts('search.popularServices', 'Beliebte Dienstleistungen') }}
      </h3>

      <ul class="text-sm grid gap-5 mt-20 lg:grid-cols-3 lg:text-base">
        <li v-for="(term, index) in popularServices" :key="index">
          <NuxtLink
            class="link flex items-center"
            :to="{
              name: 'navigator',
              query: { facets: 'services:' + term?.id },
            }"
          >
            <SpriteSymbol name="arrow" class="h-10 w-15 mr-5 inline-block" />
            <span>{{ term?.name }}</span>
          </NuxtLink>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
const { data: popularServices } = await useAsyncGraphqlQuery(
  'navigatorConfig',
  null,
  {
    transform: (v) => v.data.config?.popularServices,
    graphqlCaching: {
      client: true,
    },
    clientContext: {
      forcePharmasuisse: 'true',
    },
  },
)
</script>
